





















































































































































































































































































































































































































































































































































import {
  TimeOffRequestFieldError,
  ITimeOffRequest,
  EmployeeType,
  ICalendarHoliday,
  TimeOffRequest,
  ITimeOffAttachment,
  Employee,
  IEmployee,
  TimeOffBookingType,
  TimeOffApprover,
  TimeOffRequestAmountTypes,
  TimeOffUnitEnum,
  IUserData,
  ITimeOffAlternate,
  IUser,
  ITimeOffApprover,
  ITimeOffTypeData,
  ITimeOffUnitData,
  TimeOffStateEnum,
  IEmployeeTimeOffBookingBalance,
  IEmployeeTimeOff,
  TimeOffDurationType
} from '@/models';
import { AxiosError } from 'axios';

import { ALForm } from '@/common/component.types';

import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';
import { diffDeep, scrollToBottomOfHtmlElement } from '@/utils/helpers';
import { mapActions, mapGetters } from 'vuex';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import moment from 'moment';
import { clone, cloneDeep } from 'lodash';
import { roundToNearestHalfHour } from '@/utils/dateHelpers';

import DatePicker from '../common/DatePicker.vue';
import TimePicker from '../common/TimePicker.vue';
import EmployeeTimeOffTypePicker from '../employee-time-off/EmployeeTimeOffTypePicker.vue';
import EmployeeTimeOffEntitlementYearPicker from '../employee-time-off/EmployeeTimeOffEntitlementYearPicker.vue';
import TimeOffBookingBalanceCardDetail from './TimeOffBookingBalanceCardDetail.vue';
import TimeOffAttachmentListItem from './TimeOffAttachmentListItem.vue';
import TimeOffSupervisorEmployeePicker from './TimeOffSupervisorEmployeePicker.vue';
import EmployeeUserPicker from '../employee/EmployeeUserPicker.vue';
import EmployeePicker from '../employee/EmployeePicker.vue';
import RenderlessDragAndDrop from '../common/RenderlessDragAndDrop.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';

const baseMixins = mixins(auth);

interface Options extends InstanceType<typeof auth> {
  /* eslint-disable-next-line camelcase */

  $refs: {
    form: ALForm;
    employeeTimeOffBalanceTypePicker: InstanceType<
      typeof EmployeeTimeOffTypePicker
    >;
    employeePicker: InstanceType<typeof EmployeePicker>;
  };
}

export enum PartialOptions {
  AM,
  PM
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'TimeOffDetailForm',

    components: {
      ErrorAlert,
      DatePicker,
      EmployeeTimeOffTypePicker,
      TimeOffBookingBalanceCardDetail,
      TimeOffAttachmentListItem,
      TimeOffSupervisorEmployeePicker,
      TimePicker,
      EmployeePicker,
      EmployeeUserPicker,
      EmployeeTimeOffEntitlementYearPicker,
      RenderlessDragAndDrop,
      ALDialog,
      DragDropFileInput
    },

    data() {
      return {
        EmployeeType,
        TimeOffUnitEnum,
        TimeOffBookingType,
        TimeOffRequestAmountTypes,

        dialog: false,
        timeOffFormValid: false,
        isEdit: false,
        loading: false,

        showAlternativeApproverList: false,

        requestedBalance: 0,
        entitlementYear: null as null | number,

        effectivePickerDate: '',

        dialogBookingType: TimeOffBookingType.Personal,

        employeeBookingBalance: null as null | IEmployeeTimeOffBookingBalance,
        currentUserEmployee: {} as IEmployee,

        timeOff: {} as ITimeOffRequest,
        alternateApprover: null as IEmployee | IUser | null,

        fieldError: new TimeOffRequestFieldError(),

        dateValue: [
          moment().format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ] as string[] | string,

        errorMessage: '',
        errorMessageDetail: '',

        requiredListRules: [
          (v: any) => v.length != 0 || 'This field is required'
        ],

        requiredRules: [(v: any) => !!v || 'This field is required'],

        bookingBalanceRules: [
          (v: number) =>
            v >= 0 || 'Booking balance exceeds available entitlement'
        ],

        partialOptionList: [
          { id: PartialOptions.AM, text: 'First part of the day' },
          { id: PartialOptions.PM, text: 'Last part of the day' }
        ],

        legendList: [
          {
            state: TimeOffStateEnum.PaidHoliday,
            display_name: 'Paid Holiday',
            color: 'blue'
          },

          {
            state: TimeOffStateEnum.UnpaidHoliday,
            display_name: 'Unpaid Holiday',
            color: 'orange'
          }
        ],

        bookingBalanceValid: false
      };
    },

    computed: {
      ...mapGetters({
        getTimeOffRequestById: 'timeOffRequest/getTimeOffRequestById',
        getCalendarHolidays: 'timeOffCalendar/getCalendarHolidays',
        employeeTimeOffBalance: 'employeeTimeOff/getEmployeeTimeOffBalances',
        getEmployeeById: 'employee/getEmployeeById',
        employeeWorkSchedule: 'employee/getEmployeeWorkSchedule',
        supervisorEmployees: 'employee/getSupervisorEmployees',
        employeeTimeOffEntitlement:
          'employeeTimeOff/getEmployeeTimeOffEntitlements',
        getEmployeeTimeOff: 'employeeTimeOff/getEmployeeTimeOff'
      }),

      calendarHolidays(): ITimeOffRequest[] {
        return this.getCalendarHolidays(this.timeOff.calendar);
      },

      calendarHolidayDateList(): string[] {
        const holidays = this.getCalendarHolidays(this.timeOff.calendar).map(
          (data: ICalendarHoliday) => data.date
        );

        return holidays;
      },

      hasAlternateApprover(): boolean {
        return this.timeOff.approvers! && this.timeOff.approvers!.length > 1;
      },

      isSupervisorOutOfOffice(): boolean {
        return (
          this.dialog &&
          this.timeOff!.employee != null &&
          ((this.timeOff!.employee as IEmployee).supervisor as IEmployee) !=
            null &&
          ((this.timeOff!.employee as IEmployee).supervisor as IEmployee)
            .ooo_info != null &&
          this.dialogBookingType == TimeOffBookingType.Personal
        );
      },

      hasOOOAlternateTimeOffApprovers(): boolean {
        return (
          this.isSupervisorOutOfOffice &&
          ((this.timeOff.employee as IEmployee).supervisor as IEmployee)
            .ooo_info!.alternates!.length > 0
        );
      },

      showAlternateApproverPicker(): boolean {
        return (
          this.dialog &&
          this.supervisorEmployees.length != 0 &&
          this.dialogBookingType == TimeOffBookingType.Personal
        );
      },

      showHours(): boolean {
        let show = false;
        if (this.dialog) {
          show =
            this.dialogBookingType == TimeOffBookingType.Hourly ||
            (this.employeeBookingBalance?.employee_entitlement
              ?.timeoff_unit as ITimeOffUnitData)?.value ==
              TimeOffUnitEnum.Hours;
        }
        return show;
      },

      formTitle(): string {
        return this.dialogBookingType == TimeOffBookingType.Team
          ? 'Team Member Time off Request'
          : this.dialogBookingType == TimeOffBookingType.Personal
          ? `${this.currentUser.first_name}'s Time off Request `
          : 'Hourly Worker Time off Request';
      },

      overdraftSupported(): boolean {
        let overdraftSupported = false;

        if (
          this.employeeBookingBalance &&
          this.employeeBookingBalance.employee_entitlement
        ) {
          overdraftSupported = this.employeeBookingBalance.employee_entitlement
            .is_overdraft_supported!;
        }

        return overdraftSupported;
      }
    },

    watch: {
      dateValue: {
        handler(value) {
          this.setStartEndDate();
        }
      },

      entitlementYear: {
        handler(value: null | number) {
          if (value) {
            this.timeOff.entitlement_year = value;
            this.genEmployeeHolidays();
          }
        }
      },

      'timeOff.employee': {
        handler(value) {
          if (value && this.entitlementYear) {
            this.genEmployeeHolidays();
          } else {
            //clear year valvue if no employee is selected
            this.entitlementYear = null;
          }
        }
      }
    },

    methods: {
      moment,
      ...mapActions({
        createTimeOffRequest: 'timeOffRequest/createTimeOffRequest',
        updateTimeOffRequest: 'timeOffRequest/updateTimeOffRequest',
        deleteTimeOffAttachment: 'timeOffRequest/deleteTimeOffAttachment',
        fetchEmployeeTimeOff: 'employeeTimeOff/fetchEmployeeTimeOff',
        fetchEmployee: 'employee/fetchEmployee',
        fetchEmployeeWorkSchedule: 'employee/fetchEmployeeWorkSchedule',
        fetchEmployeeTimeOffEntitlements:
          'employeeTimeOff/fetchEmployeeTimeOffEntitlements',
        fetchCalendarHolidays: 'timeOffCalendar/fetchCalendarHolidays'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      async open(type: TimeOffBookingType, timeOff?: ITimeOffRequest) {
        this.dialogBookingType = type;

        this.requestedBalance = 0;
        this.alternateApprover = null;
        this.entitlementYear = null;
        this.showAlternativeApproverList = false;

        this.timeOff = new TimeOffRequest({
          start: moment()
            .utc(true)
            .format('YYYY-MM-DDTHH:mm:ss'),
          end: moment()
            .utc(true)
            .format('YYYY-MM-DDTHH:mm:ss'),
          type_requested: TimeOffRequestAmountTypes.FullDay
        } as ITimeOffRequest);

        if (timeOff) {
          this.timeOff = this.getTimeOffRequestById(timeOff!.id);

          //set picker date to start date
          this.effectivePickerDate = String(this.timeOff.start);

          this.entitlementYear = this.timeOff.entitlement_year;

          this.timeOff.alternates = (this.timeOff
            .alternates as ITimeOffAlternate[]).map(
            data => (data.alternate as IUserData).id!
          );

          this.alternateApprover = this.hasAlternateApprover
            ? ((this.timeOff.approvers as ITimeOffApprover[])[1]
                .approver as IUser)!
            : null;

          await this.tryGetOrFetchEmployeeWorkSchedule(
            (this.timeOff!.employee as IEmployee).id as number
          );

          if (this.dialogBookingType == TimeOffBookingType.Hourly) {
            const employeePicker = this.$refs.employeePicker;

            if (employeePicker) {
              employeePicker.debouncefetchEmployees(
                (this.timeOff!.employee as IEmployee)?.fullName
              );
            }
          }

          this.timeOff!.start = moment(this.timeOff!.start)
            .utc(false)
            .format('YYYY-MM-DDTHH:mm:ss');
          this.timeOff!.end = moment(this.timeOff!.end)
            .utc(false)
            .format('YYYY-MM-DDTHH:mm:ss');
        }

        this.requestedBalance = clone(this.timeOff!.amount_requested!);

        if (
          this.currentUser.employee &&
          this.dialogBookingType == TimeOffBookingType.Hourly
        ) {
          this.currentUserEmployee = await this.tryGetOrFetchEmployee(
            this.currentUser.employee
          );
        }

        if (
          this.currentUser.employee &&
          this.dialogBookingType == TimeOffBookingType.Personal
        ) {
          this.timeOff!.employee = await this.tryGetOrFetchEmployee(
            this.currentUser.employee
          );
          await this.fetchEmployeeWorkSchedule(
            (this.timeOff!.employee! as IEmployee).id
          );
        }

        this.isEdit = !!timeOff;

        this.clearAllErrors();

        this.updateDatePicker();

        this.dialog = true;

        this.$nextTick(() => {
          //load employee picker list
          const employeePicker = this.$refs.employeePicker;

          if (employeePicker) {
            employeePicker.debouncefetchEmployees('');
          }
        });

        this.resetFormValidation();
      },

      openAlternativeApproverList() {
        this.showAlternativeApproverList = true;
      },

      setAlternateApprover(alternate: IUser) {
        this.alternateApprover = alternate;
        this.showAlternativeApproverList = false;
      },

      setStartDate(val: string) {
        if (moment(val).isValid()) {
          this.timeOff!.start = val;
        }
      },

      setEndDate(val: string) {
        if (moment(val).isValid()) {
          this.timeOff!.end = val;
        }
      },

      formatedDate(value: string): string {
        return moment(value).format('YYYY-MM-DD');
      },

      updateDateRange(date: string): boolean {
        if (!this.employeeBookingBalance) return false;
        let isAllowedDate = this.isWithinDateRange(date);

        if (
          isAllowedDate &&
          this.employeeBookingBalance.employee_entitlement!
            .timeoff_duration_type == TimeOffDurationType.Dynamic
        ) {
          isAllowedDate = this.isWithinEmployeeEntitlementAmountDateRange(date);
        }
        return isAllowedDate;
      },

      isWithinEmployeeEntitlementAmountDateRange(date: string): boolean {
        let isWithinDateRange = false;

        const employeeEntitlementAmounts = this.employeeBookingBalance!
          .employee_entitlement!.amounts;

        for (const amount of employeeEntitlementAmounts) {
          const now = new Date();
          if (
            moment(date).isBetween(
              moment(amount.effective_date).isBefore(now)
                ? now
                : amount.effective_date, // Can not book lieu timeoff in the past
              amount.expiry_date,
              'date',
              '[]' // include date in comparison
            )
          ) {
            isWithinDateRange = true;
            // break loop early if found and move to next date check
            break;
          }
        }

        return isWithinDateRange;
      },

      isWithinDateRange(date: string): boolean {
        let isWithinRange = false;

        if (
          this.employeeBookingBalance?.employee_entitlement
            ?.timeoff_duration_type == TimeOffDurationType.Dynamic
        ) {
          isWithinRange =
            moment(date)
              .startOf('year')
              .isSameOrAfter(
                moment()
                  .set('year', this.entitlementYear!)
                  .startOf('year')
              ) &&
            moment(date)
              .endOf('year')
              .isSameOrBefore(
                moment()
                  .set('year', this.entitlementYear!)
                  .endOf('year')
              );
        } else {
          isWithinRange =
            moment(date).isSameOrAfter(
              moment(
                this.employeeBookingBalance?.employee_entitlement
                  ?.effective_date
              )
            ) &&
            moment(date).isSameOrBefore(
              moment(
                this.employeeBookingBalance?.employee_entitlement?.expiry_date
              )
            );
        }
        return isWithinRange;
      },

      async updateTimeOffStartEndYear() {
        if (
          this.employeeBookingBalance?.employee_entitlement
            ?.timeoff_duration_type == TimeOffDurationType.Dynamic
        ) {
          this.timeOff.start = this.timeOff.end = moment()
            .startOf('year')
            .isSame(
              moment()
                .set('year', this.entitlementYear!)
                .startOf('year')
            )
            ? moment().format('YYYY-MM-DD')
            : moment()
                .set('year', this.entitlementYear!)
                .startOf('year')
                .format('YYYY-MM-DD');
        } else {
          this.timeOff.start = this.timeOff.end = moment().isSameOrAfter(
            moment(
              this.employeeBookingBalance?.employee_entitlement?.effective_date
            )
          )
            ? moment().format('YYYY-MM-DD')
            : moment(
                this.employeeBookingBalance?.employee_entitlement
                  ?.effective_date
              ).format('YYYY-MM-DD');
        }

        this.effectivePickerDate = String(this.timeOff.start);

        this.updateDatePicker();
      },

      async tryGetOrFetchEmployeeTimeOff(
        employeeId: number
      ): Promise<IEmployeeTimeOff | undefined> {
        if (
          !this.getEmployeeTimeOff ||
          (this.getEmployeeTimeOff as IEmployeeTimeOff).employee != employeeId
        ) {
          await this.fetchEmployeeTimeOff(employeeId).catch(error => {
            this.errorMessage = ErrorManager.extractApiError(
              error as AxiosError
            );
          });
        }

        return this.getEmployeeTimeOff;
      },

      async tryGetOrFetchEmployee(employeeId: number): Promise<Employee> {
        if (!this.getEmployeeById(employeeId)) {
          await this.fetchEmployee(employeeId);
        }
        return this.getEmployeeById(employeeId);
      },

      async tryGetOrFetchEmployeeWorkSchedule(
        employeeId: number
      ): Promise<Employee> {
        if (!this.getEmployeeById(employeeId)) {
          await this.fetchEmployeeWorkSchedule(employeeId);
        }
        return this.getEmployeeById(employeeId);
      },

      updateDatePicker() {
        switch (this.timeOff!.type_requested) {
          case TimeOffRequestAmountTypes.Custom:
          case TimeOffRequestAmountTypes.FullDay:
            this.dateValue = [
              moment(this.timeOff?.start).format('YYYY-MM-DD'),
              moment(this.timeOff?.end).format('YYYY-MM-DD')
            ] as string[];

            break;

          case TimeOffRequestAmountTypes.Partial:
            this.dateValue = moment(this.timeOff?.start)
              .utc(true)
              .format('YYYY-MM-DD');
            break;
        }

        this.setStartEndDate();
      },

      setStartEndDate() {
        let startDate = '';
        let lastDate = '';
        let sortedDateList: string[] = [];

        //this is done to prevent a circular reference
        const dateListString = clone(this.dateValue);

        if (Array.isArray(dateListString)) {
          sortedDateList = (dateListString as string[]).sort(
            (a, b) => new Date(a).valueOf() - new Date(b).valueOf()
          );

          startDate = sortedDateList[0];

          lastDate = sortedDateList[1];
        }

        switch (this.timeOff!.type_requested) {
          case TimeOffRequestAmountTypes.FullDay: {
            this.timeOff!.start = moment(sortedDateList[0])
              .startOf('day')
              .format('YYYY-MM-DDTHH:mm:ss');

            this.timeOff!.end =
              sortedDateList.length <= 1
                ? moment(startDate)
                    .endOf('day')
                    .format('YYYY-MM-DDTHH:mm:ss')
                : moment(lastDate)
                    .endOf('day')
                    .format('YYYY-MM-DDTHH:mm:ss');

            break;
          }

          case TimeOffRequestAmountTypes.Partial: {
            this.timeOff!.start = moment(dateListString!).format(
              'YYYY-MM-DDTHH:mm:ss'
            );

            this.timeOff!.end! = moment(dateListString!).format(
              'YYYY-MM-DDTHH:mm:ss'
            );
            break;
          }

          case TimeOffRequestAmountTypes.Custom: {
            //NOTE:This was used to set the start and end date to the right time
            //because by default, the date is set to startOF and endOf day with Full Day option
            const startRoundedDate =
              moment(this.timeOff!.start)
                .startOf('day')
                .format('YYYY-MM-DDTHH:mm:ss') == this.timeOff!.start
                ? roundToNearestHalfHour()
                : this.timeOff!.start;

            const endRoundedDate =
              moment(this.timeOff!.end)
                .endOf('day')
                .format('YYYY-MM-DDTHH:mm:ss') == this.timeOff!.end
                ? moment(roundToNearestHalfHour()).add(1, 'hours')
                : this.timeOff!.end;

            this.timeOff!.start =
              moment(startDate).format('YYYY-MM-DD') +
              `T${moment(startRoundedDate).format('HH:mm:ss')}`;

            this.timeOff!.end =
              sortedDateList.length <= 1
                ? moment(startDate).format('YYYY-MM-DD') +
                  `T${moment(this.timeOff!.end).format('HH:mm:ss')}`
                : moment(lastDate).format('YYYY-MM-DD') +
                  `T${moment(endRoundedDate).format('HH:mm:ss')}`;
            break;
          }

          default:
            break;
        }
      },

      clearAllErrors(): void {
        this.fieldError.clearErrors();
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      close() {
        this.clearAllErrors();
        this.dialog = false;
        this.$emit('close');
      },

      async genEmployeeHolidays() {
        try {
          const employeeTimeOff = await this.tryGetOrFetchEmployeeTimeOff(
            (this.timeOff.employee as IEmployee).id!
          );

          this.timeOff.calendar = employeeTimeOff!.calendar as number;
          if (this.timeOff.calendar) {
            await this.fetchCalendarHolidays({
              calendarId: this.timeOff.calendar
            });
          }
        } catch (error) {
          this.errorMessage = ErrorManager.extractApiError(error as AxiosError);
        }
      },

      holidayIndicatorColor(date: string): string {
        const holiday: ICalendarHoliday = this.getCalendarHolidays(
          this.timeOff.calendar
        ).find((holiday: ICalendarHoliday) => holiday.date == date);
        return holiday.is_paid ? 'blue' : 'orange';
      },

      addTimeOffAttachments(file: File | File[]) {
        this.clearAllErrors();

        if (!this.timeOff?.attachments?.includes(file as any)) {
          const fileList = file && Array.isArray(file) ? file : [file];
          fileList.forEach(file => {
            this.timeOff?.attachFile(file);
          });
          this.$nextTick(() => {
            scrollToBottomOfHtmlElement('#scrollableAttachmentList');
          });
        }
      },

      detachTimeOffAttachment(attachment: ITimeOffAttachment) {
        this.clearAllErrors();
        this.timeOff?.detachFile(attachment.file as File);
      },

      async removeTimeOffAttachment(attachment: ITimeOffAttachment) {
        if (attachment.id) {
          return await this.deleteTimeOffAttachment({
            id: this.timeOff?.id,
            attachmentId: attachment.id
          });
        }
      },

      async saveTimeOff(): Promise<void> {
        if (this.validateForm()) {
          this.clearAllErrors();

          this.loading = true;

          const timeOffPayload = cloneDeep(this.timeOff);

          switch (this.dialogBookingType) {
            case TimeOffBookingType.Personal: {
              timeOffPayload!.approvers = await [
                new TimeOffApprover({
                  approver: ((timeOffPayload!.employee! as IEmployee)
                    .supervisor! as IEmployee).user as number
                })
              ];

              if (this.alternateApprover) {
                const approver = new TimeOffApprover({
                  approver:
                    (this.alternateApprover as IEmployee).user ??
                    this.alternateApprover.id
                });
                timeOffPayload!.approvers.push(approver);
              }

              timeOffPayload!.employee = this.currentUser.employee;
              break;
            }

            case TimeOffBookingType.Hourly:
            case TimeOffBookingType.Team: {
              // If creating or if current user is the manager or timeoff employee then add current user as approver
              const supervisor = (timeOffPayload.employee as IEmployee)
                .supervisor as IEmployee;

              const canUpdateApprover =
                !this.isEdit ||
                (supervisor && supervisor.id == this.currentUser.employee);

              if (canUpdateApprover) {
                timeOffPayload!.approvers = [
                  new TimeOffApprover({
                    approver: this.currentUser.id
                  })
                ];
              }

              timeOffPayload!.employee = (timeOffPayload!
                .employee as IEmployee).id;
              break;
            }

            default:
              break;
          }

          if (typeof timeOffPayload!.type !== 'number') {
            timeOffPayload!.type = (this.employeeBookingBalance!
              .employee_entitlement?.timeoff as ITimeOffTypeData).id;
          }

          timeOffPayload.alternates =
            this.showAlternateApproverPicker &&
            timeOffPayload.alternates &&
            timeOffPayload.alternates?.length > 0
              ? (timeOffPayload.alternates as number[]).map(
                  alternateId =>
                    ({ alternate: alternateId } as ITimeOffAlternate)
                )
              : [];

          try {
            if (this.isEdit) {
              const timeOffDelta = diffDeep(
                timeOffPayload,
                this.getTimeOffRequestById(timeOffPayload!.id),
                true
              );

              await this.updateTimeOffRequest(timeOffDelta);

              this.$emit(
                'updated',
                this.getTimeOffRequestById(timeOffDelta.id)
              );
            } else {
              await this.createTimeOffRequest(timeOffPayload);

              this.$emit('created', timeOffPayload);
            }

            this.loading = false;
            this.close();
          } catch (err) {
            this.loading = false;
            const error = err as AxiosError;
            if (error.response) {
              if (error.response.data.detail) {
                this.errorMessageDetail = error.response.data.detail;
              }
              // client received an error response that falls out of range 2xx
              if (
                TimeOffRequestFieldError.isTimeOffFieldError(
                  error.response.data
                )
              ) {
                this.fieldError = new TimeOffRequestFieldError(
                  error.response.data
                );
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          }
        }
      }
    }
  });
